/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  AttributeDisplayConfig,
  CategoryConfigFactory,
  DiffValue,
  NumericDiff,
} from "components/search/input/DifferencePanel/common";
import { NameBasedSearchPeriodParams } from "store/api/generatedApi";

export const PeriodParamsConfigFactory: CategoryConfigFactory<
  NameBasedSearchPeriodParams
> = ({ t, units, formatNumber2DP, isAdmin }) => {
  const booleanConfig: Omit<AttributeDisplayConfig<boolean>, "title"> = {
    renderDiff: ({ updatedVal, previousVal }) => {
      return (
        <DiffValue>
          {previousVal ? t("yes") : t("no")} → {updatedVal ? t("yes") : t("no")}
        </DiffValue>
      );
    },
    format: (val) => (val ? t("yes") : t("no")),
  };
  const dateConfig: Omit<AttributeDisplayConfig<string | null>, "title"> = {
    format: (val) => new Date(val).toLocaleString(),
    renderDiff: ({ updatedVal, previousVal }) => {
      if (!previousVal) {
        if (!updatedVal) {
          throw new Error("Both previous and updated values are null");
        }
        return <DiffValue>{new Date(updatedVal).toLocaleString()}</DiffValue>;
      } else if (!updatedVal) {
        return <DiffValue>{new Date(previousVal).toLocaleString()}</DiffValue>;
      }
      return (
        <DiffValue>
          {new Date(previousVal).toLocaleString()} →{" "}
          {new Date(updatedVal).toLocaleString()}
        </DiffValue>
      );
    },
  };
  return {
    ...(isAdmin
      ? {
          optimisation_objective_weighting: {
            title: t("optimisationObjectiveWeighting"),
            renderDiff: ({ updatedVal, previousVal }) => {
              return (
                <NumericDiff
                  previous={previousVal ?? 0}
                  updated={updatedVal ?? 0}
                  format={formatNumber2DP}
                />
              );
            },
            format: (val) => formatNumber2DP(val),
          },
          suppress_mix_material_exclusivity_constraints: {
            title: `${t("suppressConstraints")}: ${t(
              "mixMaterialExclusivity"
            )}`,
            ...booleanConfig,
          },
          suppress_min_feasible_mass_constraints: {
            title: `${t("suppressConstraints")}: ${t("minimumFeasibleMass")}`,
            ...booleanConfig,
          },
          // Not editable in the UI (yet?)
          is_deployable: {
            title: t("isDeployable"),
            ...booleanConfig,
          },
        }
      : {}),
    electrical_energy_price: {
      title: t("electricalEnergyPrice"),
      renderDiff: ({ updatedVal, previousVal }) => {
        return (
          <NumericDiff
            previous={previousVal ?? 0}
            updated={updatedVal ?? 0}
            prefix={units("cost")}
            format={formatNumber2DP}
          />
        );
      },
      format: (val) => `${units("cost")}${formatNumber2DP(val)}`,
    },
    start_timestamp: {
      title: t("startTime"),
      ...dateConfig,
    },
    end_timestamp: {
      title: t("endTime"),
      ...dateConfig,
    },
  };
};
